import axios from 'axios';

import { API_URL } from './config';

export const signup = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/signup`, { username, password });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Registro falló. Intente nuevamente.');
  }
};

export const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, { username, password }, {
      withCredentials: true, // ✅ Needed for cookies/auth
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Inicio de sesión falló. Intente nuevamente.');
  }
};

export const getToken = () => {
  try{
    const token = document.cookie?.split('; ').find((row) => row.startsWith('token='))?.split('=')[1];
    if (!token) {
      throw new Error('No se encontró token');
    }
    return token;
  } catch (error) {
    window.location.href = '/';
  }
}

export const tokenExists = () => {
  const token = document.cookie?.split('; ').find((row) => row.startsWith('token='))?.split('=')[1];
  return !!token;
}


export const handleLogout = () => {
  document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  localStorage.removeItem('selectedBranchId');
  window.location.reload();
};


export const getMe = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${API_URL}/auth/me`, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error al obtener usuario');
  }
};

export const updateMyName = async (data) => {
  const token = getToken();
  try {
    const response = await axios.patch(`${API_URL}/auth/me`, data, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error al actualizar nombre');
  }
}
